import {DriverLocationEntity} from "@ots-frontend/ots-data";
import {EntityMarker, EntityMarkerProps} from "../../marker/EntityMarker/EntityMarker";
import { gpsMarkerColor } from "../../../../theme/colors"

const MARKER_URI = `data:image/svg+xml,%3Csvg%20%20xmlns=%22http://www.w3.org/2000/svg%22%20%20width=%2224%22%20%20height=%2224%22%20%20viewBox=%220%200%2024%2024%22%20%20fill=%22${gpsMarkerColor.replace("#", "%23")}%22%20%20class=%22icon%20icon-tabler%20icons-tabler-filled%20icon-tabler-keyframe%22%3E%3Cpath%20stroke=%22none%22%20d=%22M0%200h24v24H0z%22%20fill=%22none%22/%3E%3Cpath%20d=%22M12%204a2.599%202.599%200%200%200%20-2%20.957l-4.355%205.24a2.847%202.847%200%200%200%20-.007%203.598l4.368%205.256c.499%20.6%201.225%20.949%201.994%20.949a2.599%202.599%200%200%200%202%20-.957l4.355%20-5.24a2.847%202.847%200%200%200%20.007%20-3.598l-4.368%20-5.256a2.593%202.593%200%200%200%20-1.994%20-.949z%22%20/%3E%3C/svg%3E`

export type DriverLocationMarkersProps =
  Omit<EntityMarkerProps<DriverLocationEntity>, 'entity' | 'position' | 'options' | 'icon' | 'title'>
  & {
  driverLocations: DriverLocationEntity[];
}

export const DriverLocationMarkers = (props: DriverLocationMarkersProps) => {
  const {driverLocations, ...rest} = props


  return (
    <>
      {driverLocations.map((dl, index) => {
        return (
          <EntityMarker
            {...rest}
            key={"dl_" + index + "_" + dl.id}
            entity={dl}
            position={{
              lat: dl.coordinates!.latCoord,
              lng: dl.coordinates!.longCoord,
            }}
            icon={{
              url: MARKER_URI
            }}
          />
        )
      })}
    </>
  )
}
